import styled from 'styled-components';

import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';

export const LoginGuestBanner = styled(LoginBanner)`
    padding: 49px 56px;
`;
